export const errorMessages = {
	METHOD_NOT_ALLOWED : 'This feature is blocked due to its subscription level!'
};
